import { featuresData } from '@/mocks/home';

export default function SectionFeatures() {
  return (
    <section id="features" className="py-12 md:py-16 px-4 md:px-6 bg-background-100" style={{ scrollMarginTop: '4rem' }}>
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading font-bold text-xl md:text-2xl lg:text-3xl text-foreground-950 mb-2">
            平台特色
          </h2>
          <p className="text-sm text-foreground-500">为什么千万瓜友选择51吃瓜网</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {featuresData.map((item, i) => (
            <div key={i} className="bg-background-50 rounded-xl p-5 border border-background-200/70 hover:border-primary-200 transition-colors text-center group cursor-pointer">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-primary-50 text-primary-600 group-hover:bg-primary-100 transition-colors mb-4">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-950 mb-2">{item.title}</h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}